import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-store-integrations',
  templateUrl: './store-integrations.component.html',
  styleUrls: ['./store-integrations.component.css']
})
export class StoreIntegrationsComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  storeDetails: string = 'N'
  mId: any;
  storeManagementp: string = 'N'
  storeManagement: any = [];
  enableStatus: boolean = false;
  enableMagento: boolean = false;
  enableOpencart: boolean = false;
  enablePrestaShop: boolean = false;
  enableStoreHippo: boolean = false;
  enableGoogleSheet: boolean = false;
  enableAmazon: boolean = false;
  enableShopclues: boolean = false;
  enableFlipkart: boolean = false;
  enableEbay: boolean = false;
  enableZohoCommerce: boolean = false;
  enableShopify: boolean = false;
  enableWoocommerce: boolean = false;
  enableBigcommerce: boolean = false;
  enableSnapdeal: boolean = false;
  sync: string = 'N';
  deleteApiPop: string = 'N';
  store: any = {
    syncType: ""
  };
  checkedList = [];
  users: any;
  index: any;
  masterSelectedManageUser: boolean = false;
  errorMessage: string;
  errorMessage2: string;
  statusText: string;
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statusText8: string;
  statusText9: string;
  statusText10: string;
  statusText11: string;
  statusText12: string;
  statusText13: string;
  statusText14: string;
  statusText15: string;
  statusText16: string;
  statusText17: string;
  statusText18: string;
  statusText19: string;
  statusText20: string;
  statusText21: string;
  storeManage: any = {};
  shopifyProducts: any;
  wooProducts: any;
  shopifyOrders: any;
  wooOrders: any;
  magentoProducts: any;
  magentoOrders: any;
  ebayProducts: any;
  ebayOrders: any;
  flipkartOrders: any;
  shopcluesProducts: any;
  shopcluesOrders: any;
  tabClicked = "active";


  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router) {
    this.getStoreList("ACTIVE");
  }

  getStoreList(status) {
    this.api.getAllStoreManagementData(this.user.accountOwnerId, status, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      if (data.storeManagementResponses.length === 0 && status === "ACTIVE") {
        this.router.navigate(['/admin/storeConnections']);
      } else {
        this.storeManagement = data.storeManagementResponses;
        this.storeManagement.forEach((s: any) => {
          if (s.status === 'ACTIVE' && s.storeType == 'MAGENTO') {
            s.enableMagento = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'SHOPCLUES') {
            s.enableShopclues = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'AMAZON') {
            s.enableAmazon = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'FLIPKART') {
            s.enableFlipkart = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'SHOPIFY') {
            s.enableShopify = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'EBAY') {
            s.enableEbay = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'WOOCOMMERCE') {
            s.enableWoocommerce = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'BIGCOMMERCE') {
            s.enableBigcommerce = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'SNAPDEAL') {
            s.enableSnapdeal = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'OPENCART') {
            s.enableOpencart = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'ZOHO_COMMERCE') {
            s.enableZohoCommerce = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'PRESTASHOP') {
            s.enablePrestaShop = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'STORE_HIPPO') {
            s.enableStoreHippo = true;
          }
          if (s.status === 'ACTIVE' && s.storeType == 'GOOGLESHEET') {
            s.enableGoogleSheet = true;
          }
        });
      }
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  tabChange() {
    this.checkedList = [];
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }


  getStoreManagement() {
    this.api.getAllStoreManagementData(this.user.accountOwnerId, status, this.user.organizationId).subscribe((data: any) => {
      this.storeManagement = data.storeManagementResponses;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  populateTabData(triggered) {
    this.tabClicked = triggered;
  }


  getStoremanagement(m: any = {}, type = '') {
    if (type == 'MAGENTO') {
      this.router.navigate(['/admin/manageStoreManagement', { type, id: m.id }]);
    } else if (type == 'SHOPIFY') {
      this.router.navigate(['/admin/shopifyManageStoreManagement', { type, id: m.id }]);
    } else if (type == 'PRESTASHOP') {
      this.router.navigate(['/admin/prestaShopManage', { type, id: m.id }]);
    } else if (type == 'EBAY') {
      this.router.navigate(['/admin/ebayManageStoreManagement', { type, id: m.id }]);
    } else if (type == 'FLIPKART') {
      this.router.navigate(['/admin/flipkartManageStoreManagement', { type, id: m.id }]);
    } else if (type == 'SHOPCLUES') {
      this.router.navigate(['/admin/shopcluesManageStoreManagement', { type, id: m.id }]);
    } else if (type == 'WOOCOMMERCE') {
      this.router.navigate(['/admin/woocommerceManageStoreManagement', { type, id: m.id }]);
    } else if (type == 'AMAZON') {
      this.router.navigate(['/admin/amazonManageStoreManagement', { type, id: m.id }]);
    } else if (type == 'SNAPDEAL') {
      this.router.navigate(['/admin/snapdealManageStoreManagement', { type, id: m.id }]);
    } else if (type == 'BIGCOMMERCE') {
      this.router.navigate(['/admin/bigCommerceManageStoreManagement', { type, id: m.id }]);
    } else if (type == 'BIGCOMMERCE') {
      this.router.navigate(['/admin/bigCommerceManageStoreManagement', { type, id: m.id }]);
    } else if (type == 'OPENCART') {
      this.router.navigate(['/admin/opencartManageStoreManagement', { type, id: m.id }]);
    } else if (type == 'ZOHO_COMMERCE') {
      this.router.navigate(['/admin/zohoCommerceManageStoreManagement', { type, id: m.id }]);
    } else if (type == 'STORE_HIPPO') {
      this.router.navigate(['/admin/storeHippoManage', { type, id: m.id }]);
    } else if (type == 'GOOGLESHEET') {
      this.router.navigate(['/admin/googleSheetManage', { type, id: m.id }]);
    }

    this.g.loaderDisplay = "display";
    this.api.getStoreManagementById(m.id, this.user.accountOwnerId, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.storeManage = data;
      this.mId = this.storeManage.id;

    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }


  updateStatus(connectionName = '', status, id, index) {
    if (status) {
      this.storeManagement.status == 'ACTIVE';
    } else {
      this.storeManagement.status == 'IN_ACTIVE';
    }
    let api = "";
    this.g.loaderDisplay = "display";
    if (status) {
      api = 'api/activateStore';
      this.storeManagement.status = "ACTIVE";
    } else {
      api = 'api/deActivateStore';
      this.storeManagement.status = "IN_ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + api, {
      "id": id,
      "accountOwnerId": this.user.accountOwnerId,
      "organizationId": this.user.organizationId,
      "status": this.storeManagement.status
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.storeManagement.splice(index, 1);
          // this.rerender();
          this.alertService.success('', 'Status Updated Successfully');
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  modifyStatus(connectionName = '', id, index) {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/archiveStore', {
      "id": id,
      "accountOwnerId": this.user.accountOwnerId,
      "organizationId": this.user.organizationId,
      "status": "ARCHIVED"
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.storeManagement.splice(index, 1);
          // this.rerender();
          this.alertService.success('', 'Status Updated Successfully');
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  removeStore(index) {
    this.deleteApiPop = 'Y';
    this.index = index;
  }

  closePopup() {
    this.deleteApiPop = 'n';
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20
    };
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  showConnectBtn(type) {
    let show = false;
    if (this.storeManagement) {
      this.storeManagement.forEach((s) => {
        if (s.storeType === type) {
          show = true
        }
      });
    }
    return show;
  }

  changeStatus(c, id) {
    let api = "";
    this.g.loaderDisplay = "display";
    if (c.enabled) {
      api = 'api/deActivateStore';
      c.status = "IN_ACTIVE";
    } else {
      api = 'api/activateStore';
      c.status = "ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + api, {
      "id": id,
      "accountOwnerId": this.user.accountOwnerId,
      "organizationId": this.user.organizationId,
      "status": status
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.alertService.success();
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  testConnection(s) {
    let api = "";
    let connectName = "";
    if (s.connectionName != "") {
      connectName = s.connectionName;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    if (s.storeType == 'MAGENTO') {
      api = 'api/testMagentoConnection/?accountOwnerId=' + this.user.accountOwnerId + '&organizationId=' + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'SHOPIFY') {
      api = 'api/testShopifyConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'AMAZON') {
      api = 'api/testAmazonConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'EBAY') {
      api = 'api/testEbayConnection?accountOwnerId=' + this.user.accountOwnerId + '&storeId=' + s.id;
    } else if (s.storeType == 'FLIPKART') {
      api = 'api/testFlipkartConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'SHOPCLUES') {
      api = 'api/testShopCluesConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'WOOCOMMERCE') {
      api = 'api/testWoocommerceConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'SNAPDEAL') {
      api = 'api/testSnapdealConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'OPENCART') {
      api = 'api/testOpenCartConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'BIGCOMMERCE') {
      api = 'api/testBigcommerceConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'PRESTASHOP') {
      api = 'api/testPrestaShopConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'ZOHO_COMMERCE') {
      api = 'api/testZohoCommerceConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'STORE_HIPPO') {
      api = 'api/testStoreHippoConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    } else if (s.storeType == 'GOOGLESHEET') {
      api = 'api/testStoreHippoConnection?accountOwnerId=' + this.user.accountOwnerId + "&organizationId=" + this.user.organizationId + '&storeId=' + s.id;
    }
    this.http.post(environment.apiUrl + api, {},
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.alertService.success(s.storeType, 'Connected Successfully');
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
